import type { FC } from 'react';

import {
  AlsoConnectedTo,
  CallDetailsAddHearing,
  CallDetailsParticipant,
} from 'features/call/call-details/components';
import type { CallDetailsParticipantInfo } from 'features/call/call-details/interfaces';
import { Separator } from 'features/call/call-details/styles';
import { CustomGreeting } from 'features/custom-greeting/components';

export interface CallDetailsCalleeReconnectProps {
  callee: CallDetailsParticipantInfo;
  caller: CallDetailsParticipantInfo;
}

export const CallDetailsCalleeReconnect: FC<
  CallDetailsCalleeReconnectProps
> = ({ callee, caller }) => {
  return (
    <>
      <CustomGreeting />
      <CallDetailsParticipant {...caller} />
      <Separator />
      <CallDetailsParticipant {...callee} />
      <CallDetailsAddHearing />
      <AlsoConnectedTo />
    </>
  );
};
